import { GeofenceStateParam } from '@casops/store/apis/commonModels';
import { setGeofenceState } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import SingleSelectFilter from '../single-select/SingleSelectFilter';
import { FilterInputProps } from '@casops/filters/types';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { ReactElement, useMemo } from 'react';
import { useIsGeofenceManagement } from '@casops/permissions';

const useGeofenceStateOptions = (): DropdownItemProps<GeofenceStateParam>[] => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.values(GeofenceStateParam).map(value => ({
        key: value,
        value,
        stringValue: value,
        label: t(`GeofenceStateParam.${value}`),
      })),
    [t],
  );
};

export const GeofenceStateFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>): ReactElement | null => {
  const { t } = useTranslation();
  const isAllowed = useIsGeofenceManagement();

  return isAllowed ? (
    <SingleSelectFilter<GeofenceStateParam>
      filterName="geofenceState"
      label={label ?? t('Fields.Filters.GeofenceState')}
      elementRef={elementRef}
      action={setGeofenceState}
      useItemsHook={useGeofenceStateOptions}
    />
  ) : null;
};

export default GeofenceStateFilter;
